import { render, staticRenderFns } from "./FreeLines.vue?vue&type=template&id=6abf2dae"
import script from "./FreeLines.vue?vue&type=script&lang=ts"
export * from "./FreeLines.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6abf2dae')) {
      api.createRecord('6abf2dae', component.options)
    } else {
      api.reload('6abf2dae', component.options)
    }
    module.hot.accept("./FreeLines.vue?vue&type=template&id=6abf2dae", function () {
      api.rerender('6abf2dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/FreeLines.vue"
export default component.exports